<template>
	<div v-if="isVisible">
	  <div class="overlay" @click="closePopup"></div>
  
	  <section class="module-apology-popup">
		<button class="close" @click="closePopup">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M18 6L6 18" stroke="#BA2324" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M6 6L18 18" stroke="#BA2324" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			ZAMKNIJ
		</button>
		<div class="wrapper">
			<p class="left">Sygn. akt XK 167/22</p>
			<p class="bold center">WYROK<br>W IMIENIU RZECZYPOSPOLITEJ POLSKIEJ</p>
			<p class="right">6 grudnia 2024 roku</p>
			<p class="bold center">Sąd Rejonowy dla Warszawy - Śródmieścia w Warszawie X Wydział Karny<br>w składzie: Przewodnicząca: Sędzia Marta Pilśnik<br>Protokolant: Julia Stołowska</p>
			<p class="bold">przy udziale oskarżycielki prywatnej Aleksandry Brejzy</p>
			<p>po rozpoznaniu na rozprawie 29 marca 2023 roku, 28 kwietnia 2023 roku, 27 lipca 2023 roku, 17 listopada 2023 roku, 27 lutego 2024 roku, 4 września 2024 roku i 22 listopada 2024 roku w Warszawie</p>
			<p>sprawy <span class="bold">Samuela Rodrigo Pereiry</span>, syna Nelsona i Katarzyny z domu Kevin urodzonego 16 września 1988 roku w Warszawie</p>
			<p class="bold">oskarżonego o to, że:</p>
			<p>w dniu 9 września 2019 roku o godzinie 9.48 w Warszawie opublikował na łamach serwisu społecznościowego „Twitter” wpis „Krzysztof Brejza manipuluje strasznie. Aktywna politycznie Aleksandra Brejza brała udział w atakach na oponentów prezydenta Brejzy i posła Brejzy (minister sprawiedliwości w gabinecie cieni PO). [...], do którego załączył opublikowany w dniu 9 września 2019 roku w portalu internetowym tvp.info artykuł pt. &lt;&lt;Weźcie klikajcie, rozruszaj trochę towarzystwo&gt;&gt;. Jak żona Brejzy hejt ustawiała”, w którym zarzucił Aleksandrze Brejzie, że brała udział w organizowaniu ataków na oponentów politycznych jej męża – prezydenta miasta Inowrocławia Ryszarda Brejzę oraz syna – posła Krzysztofa Brejzę, w szczególności poprzez „ustawianie” przeciwko nim tzw. hejtu, przez co publicznie pomówił Aleksandrę Brejzę o takie postępowanie, które mogło poniżyć ją w opinii publicznej lub narazić na utratę zaufania potrzebnego dla pełnienia funkcji nauczyciela akademickiego,</p>
			<p class="bold">tj. o czyn z art. 212 § 2 kk</p>
			<p class="bold center">orzeka:</p>
			<p><span class="bold">I.</span> oskarżonego <span class="bold">Samuela Rodrigo Pereirę</span> uznaje za winnego popełnienia zarzucanego mu czynu z tym że ustala, że publiczne pomówienie Aleksandry Brejzy mogło poniżyć ją w opinii publicznej i narazić na utratę zaufania potrzebnego dla pełnienia funkcji nauczyciela akademickiego i za to na podstawie art. 212 § 2 kk wymierza mu karę 250 (dwustu pięćdziesięciu) stawek dziennych grzywny, ustalając wysokość jednej stawki na 100,00 (sto złotych);</p>
			<p><span class="bold">II.</span> na podstawie art. 212 § 3 kk orzeka wobec oskarżonego Samuela Rodrigo Pereiry nawiązkę w wysokości 15.000,00 (piętnastu tysięcy) złotych na rzecz Aleksandry Brejzy;</p>
			<p><span class="bold">III.</span> na podstawie art. 215 kk w zw. z art. 43b kk orzeka o podaniu wyroku do publicznej wiadomości, poprzez umieszczenie jego treści na tablicy ogłoszeń Sądu przez okres 1 (jednego) miesiąca oraz na portalu www.tvp.info w formie tzw. wyskakującego okienka, utrzymującego się na ekranie przez co najmniej 20 sekund o formacie 886 x 886 pikseli przy rozdzielczości 150 dpi, czarną czcionką Times New Roman o rozmiarze 12, na białym tle, przez okres 14 (czternastu) dni;</p>
			<p><span class="bold">IV.</span> na podstawie art. 628 kpk zasądza od oskarżonego Samuela Rodrigo Pereiry na rzecz oskarżycielki prywatnej Aleksandry Brejzy 300,00 (trzysta) złotych, tytułem zwrotu zryczałtowanej równowartości wydatków.</p>
		</div>
	  </section>
	</div>
</template>
  
<script setup>
	import { ref, onMounted, watch, onBeforeUnmount } from 'vue';

	const isVisible = ref(false);
	let autoCloseTimer = null;

	function closePopup() {
		isVisible.value = false;
		sessionStorage.setItem('apologyPopupClosed', 'true');
	}

	onMounted(() => {
		const hasClosed = sessionStorage.getItem('apologyPopupClosed');

		const limitDate = new Date('2025-10-06T10:30:00+02:00'); 
		const now = new Date();

		if (now < limitDate && !hasClosed) {
			isVisible.value = true;
			
			autoCloseTimer = setTimeout(() => {
				closePopup();
			}, 21000);
		}
	});

	watch(isVisible, (val) => {
		if (val) {
			document.body.style.overflow = 'hidden';
			document.documentElement.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
			document.documentElement.style.overflow = '';
		}
	});

	onBeforeUnmount(() => {
		if (autoCloseTimer) clearTimeout(autoCloseTimer);
		document.body.style.overflow = '';
		document.documentElement.style.overflow = '';
	});
</script>
  
<style scoped lang="scss">
.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.2);
	z-index: 999998;
}

.module-apology-popup {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 886px;
	height: 886px;
	max-width: 100vw;
	max-height: 92vh;
	max-height: 98dvh;
	background: #fff;
	padding: 40px 10px 20px;
	z-index: 999999;
	overflow: hidden;

	@media (min-width: $desktop) {
		padding: 70px 20px 50px;
	}
	.wrapper {
		font-family: 'Times New Roman', Times, serif;
		font-size: 12px;
		line-height: 18px;
		padding: 0 15px 0 5px;
		color: black;
		overflow-y: auto;
		overflow-x: hidden;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		touch-action: pan-y;

		&::-webkit-scrollbar {
			width: 6px; 
		}
		&::-webkit-scrollbar-thumb {
			background: rgba(0, 0, 0, 0.3);
			border-radius: 6px;
		}
		&::-webkit-scrollbar-track {
			background: transparent; 
		}

		p:not(:last-child) {
			margin-bottom: 12px;
		}
		.bold {
			font-weight: bold;
		}
		.left {
			text-align: left;
		}
		.right {
			text-align: right;
		}			
		.center {
			text-align: center;
		}

		@media (min-width: $desktop) {
			padding: 0 40px;
		}
	}
	.close {
		color: #BA2324;
		font-size: 14px;
		position: absolute;
		top: 10px;
		right: 6px;
		background: none;
		border: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 5px;

		&:hover {
			text-decoration: underline;
		}

		@media (min-width: $desktop) {
			top: 20px;
			right: 30px;
		}
	}
}
</style>
